/* eslint-disable no-unused-vars */

import React, { useEffect, useMemo, useState } from 'react';
import Lightbox from 'react-awesome-lightbox';
import _ from 'lodash';

import DeleteModal from '@components/modal/variants/delete-modal';
import Icon from '@components/icon-component';

import style from './photo.module.scss';
import 'react-awesome-lightbox/build/style.css';
import useWindowDimensions from '@hooks/useWindowDimensions';
import {
  deleteAssetInIndexDB,
  getAssetDataBase64InIndexDB
} from '@utilities/photos-documents.util';
import LoadingRound from '@components/loading-round/loading-round';

const PhotoCardComponent = ({
  image,
  imageUrl = null,
  categoryValue,
  captionValue,
  deleteBtnEvent,
  editBtnEvent,
  photoId,
  editable = true,
  imageName,
  viewableImages = false,
  isImagesFailedDuringFetch = false
}) => {
  const [showFullImage, setShowFullImage] = useState(false);
  const [deletePic, setDeletePic] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const { width } = useWindowDimensions();
  const [imageURL1, setImageURL] = useState('');
  const [imgError, setImgError] = useState(false);
  // const [isImagePreview, setImagePreview] = useState(false);

  useEffect(() => {
    return () => {
      setImageURL('');
      setLoadingImage(false);
      setLoading(false);
      setDeletePic();
    };
  }, []);

  useEffect(() => {
    generateImageURL();
  }, [photoId, image, categoryValue, captionValue]);

  useEffect(() => {
    return () => {
      setShowFullImage(false);
      setDeletePic(null);
      setLoading(false);
    };
  }, []);

  useEffect(() => {
    showFullImage && (document.body.style.overflow = 'hidden');
    !showFullImage && (document.body.style.overflow = 'unset');
  }, [showFullImage]);

  const openImageInFullScreen = (imageUrl, imageName) => {
    return (
      <Lightbox
        allowZoom={false}
        allowRotate={false}
        showTitle={false}
        image={imageUrl}
        title={imageName}
        onExit={() => {
          setShowFullImage(false);
        }}
        onClose={() => {
          setShowFullImage(false);
        }}
      />
    );
  };

  const handleDeleteEvent = async () => {
    setLoading(true);

    try {
      await deleteAssetInIndexDB({ assetId: image?.id, deleteAll: true });
    } catch (error) {
      console.log('error deleting data');
    }

    await deleteBtnEvent(photoId, image?.id);
    setDeletePic(false);
    setLoading(false);
  };

  // const srcImageURL = useMemo(() => {
  //   return !_.isEmpty(imageUrl)
  //     ? imageUrl
  //     : (image && image?.base64 && `data:image/png;base64,${image.base64}`) || '';
  // }, [imageUrl, image]);

  let generateImageURL = async () => {
    try {
      setLoadingImage(true);
      if (!_.isEmpty(imageUrl)) {
        setImageURL(imageUrl);
      } else {
        let cond = image?.type === 'image/heic' || image?.type === 'image/heif';
        if (!cond) {
          const base64 = await getAssetDataBase64InIndexDB({ assetId: image?.id });
          const srcImageURL = base64 ? `data:image/png;base64,${base64}` : '';
          srcImageURL && setImageURL(srcImageURL);
        }
      }
    } catch (error) {
      console.log('error');
    } finally {
      setLoadingImage(false);
    }
  };

  return (
    <>
      {showFullImage &&
        openImageInFullScreen(
          !_.isEmpty(imageUrl)
            ? imageUrl
            : image && image?.base64 && `data:image/png;base64,${image.base64}`,
          imageName ? imageName : 'no-image'
        )}

      <div className={style.cardDiv}>
        {loadingImage ? (
          <LoadingRound className={style.loaderHeight} />
        ) : (
          <>
            <div
              className={`${style.imgDiv} ${
                _.isEmpty(categoryValue) && _.isEmpty(captionValue) && style.noBorderBottom
              } `}
            >
              {imageURL1 && !imgError ? (
                <img
                  className={style.img}
                  src={imageURL1}
                  alt={imageName ? imageName : 'no-image'}
                  onClick={() => setShowFullImage(true)}
                  onError={(e) => {
                    console.log('image error', e);
                    setImgError(true);
                  }}
                />
              ) : viewableImages || imgError ? (
                <>
                  <div id="no-image-container" className={style.noImageContainer}>
                    <div className={style.info}>
                      {isImagesFailedDuringFetch && imageURL1 ? (
                        <span>
                          Photo was not downloaded due to an interruption to your internet
                          connection while getting additional data.
                        </span>
                      ) : (
                        <span>
                          Photo was not downloaded due to settings in More{' '}
                          <Icon name="arrow-right-gray" className={style.icon} /> Settings{' '}
                          <Icon name="arrow-right-gray" className={style.icon} /> Attachments.
                        </span>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            {!_.isEmpty(categoryValue) || !_.isEmpty(captionValue) ? (
              <div className={style.bottomDiv}>
                {!_.isEmpty(categoryValue) && (
                  <>
                    <h1 className={style.category}>Category</h1>
                    <p>{categoryValue}</p>
                  </>
                )}

                {!_.isEmpty(captionValue) && (
                  <>
                    <h1 className={style.category}>Caption</h1>
                    <p>{captionValue}</p>
                  </>
                )}
              </div>
            ) : (
              <div></div>
            )}
            {editable && (
              <div className={style.sectionLast}>
                <Icon name={'delete'} alt="delete" onClick={() => setDeletePic(true)} />
                <Icon name={'edit-circle'} alt="edit" onClick={() => editBtnEvent(photoId)} />
              </div>
            )}
          </>
        )}
      </div>

      <DeleteModal
        open={deletePic}
        setOpen={loading ? () => {} : setDeletePic}
        handleDelete={handleDeleteEvent}
        confirmDeletion
        recordType="photo"
        disabledDeleteButton={loading}
      />
    </>
  );
};

export default PhotoCardComponent;
